module.exports = __webpack_public_path__ + "img/kr-product-card3-item2-step4.56a1089.png";